import { InjectionToken } from '@angular/core';
import { DepositAssetsFacade } from './deposit-assets.facade';

export const DEPOSIT_ASSETS_FACADE =
  new InjectionToken<DepositAssetsFacade>('DEPOSIT_ASSETS_FACADE');